import { createTheme } from '@mantine/core';

export const theme = createTheme({
  fontFamily: 'Inter, sans-serif',
  headings: {
    fontFamily: 'Playfair Display, serif',
  },
  colors: {
    // Soft, romantic color palette
    wedding: [
      '#fdf2f8', // lightest pink
      '#fce7f3', // very light pink
      '#fbcfe8', // light pink
      '#f9a8d4', // medium light pink
      '#f472b6', // medium pink
      '#ec4899', // main pink
      '#db2777', // darker pink
      '#be185d', // dark pink
      '#9d174d', // very dark pink
      '#831843', // darkest pink
    ],
    sage: [
      '#f6f7f6', // lightest sage
      '#e8ebe8', // very light sage
      '#d1d9d1', // light sage
      '#a8b8a8', // medium light sage
      '#7f967f', // medium sage
      '#5a735a', // main sage
      '#4a5f4a', // darker sage
      '#3a4b3a', // dark sage
      '#2a372a', // very dark sage
      '#1a231a', // darkest sage
    ],
  },
  primaryColor: 'wedding',
  defaultRadius: 'md',
  other: {
    titleColor: '#719ebd', // Main color for section titles (replaces gradient)
    secondaryColor: '#F4C2C2', // Secondary accent color for highlights and accents
  },
  spacing: {
    xs: '0.5rem',
    sm: '0.75rem',
    md: '1rem',
    lg: '1.5rem',
    xl: '2rem',
    xxl: '3rem',
  },
  breakpoints: {
    xs: '30em',
    sm: '48em',
    md: '64em',
    lg: '74em',
    xl: '90em',
  },
});
